import { Platform } from 'react-native';
import { API_BASE_URL } from '@/config/api';
import { createRefreshCookieFetch } from '@/utils/refreshCookieFetch';

/**
 * Browser build only: moves the refresh token into an HttpOnly cookie where the browser allows it (see
 * utils/refreshCookieFetch.ts). On the phone this does nothing.
 */
export function installWebRefreshCookie(): void {
  if (Platform.OS !== 'web' || typeof window === 'undefined' || !API_BASE_URL) return;
  const marked = window as unknown as { __refreshCookieInstalled?: boolean };
  if (marked.__refreshCookieInstalled) return;
  marked.__refreshCookieInstalled = true;
  window.fetch = createRefreshCookieFetch(window.fetch.bind(window), API_BASE_URL);
}
